"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebSocketClient = void 0;
var endpoints_1 = __importDefault(require("./endpoints"));
var socket_io_client_1 = require("socket.io-client");
var sweetalert2_1 = __importDefault(require("sweetalert2"));
var oauth2_client_1 = require("./oauth2-client");
var WebSocketClient = /*#__PURE__*/function () {
  function WebSocketClient(appId, accessToken, refreshToken, expiresIn, server) {
    var env = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    _classCallCheck(this, WebSocketClient);
    this.endpoints = new endpoints_1.default();
    this.server = '';
    this.confirmUrl = this.endpoints.getConfirmUrl();
    this.confirmArray = [];
    this.swalPromise = null;
    this.endpoints = new endpoints_1.default(env);
    this.server = this.endpoints.getWsServer();
    this.confirmUrl = this.endpoints.getConfirmUrl();
    this.appId = appId;
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.oAuth2Client = new oauth2_client_1.Oauth2Client();
    var oauthUser = {
      appId: appId,
      accessToken: accessToken,
      refreshToken: refreshToken,
      expiresIn: expiresIn,
      expriesAt: new Date().getTime() + (expiresIn - 5) * 1000
    };
    this.oAuth2Client.setUser(oauthUser);
    if (server) {
      this.server = server.indexOf('/wss/mts-l2') > 0 ? server : server + '/wss/mts-l2';
    }
  }
  _createClass(WebSocketClient, [{
    key: "log",
    value: function log() {
      for (var _len = arguments.length, obj = new Array(_len), _key = 0; _key < _len; _key++) {
        obj[_key] = arguments[_key];
      }
      console.log(obj);
    }
  }, {
    key: "handleRefreshToken",
    value: function handleRefreshToken(callback) {
      var _this = this;
      var _a, _b;
      if (new Date().getTime() < ((_a = this.oAuth2Client.oauth2User) === null || _a === void 0 ? void 0 : _a.expriesAt)) {
        if (callback) {
          callback.apply(this);
        }
        return;
      }
      this.oAuth2Client.refreshToken(this.appId, (_b = this.oAuth2Client.oauth2User) === null || _b === void 0 ? void 0 : _b.refreshToken, function (oauth2User) {
        _this.accessToken = oauth2User.accessToken;
        _this.refreshToken = oauth2User.refreshToken || '';
        if (callback) {
          callback.apply(_this);
        }
      });
    }
  }, {
    key: "connect",
    value: function connect(onEmitChain, onMessage, onJson, onConnect, onDisconnect) {
      var _this2 = this;
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      if (!this.server || !this.accessToken) {
        return false;
      }
      this.onEmitChain = onEmitChain;
      this.onMessage = onMessage;
      this.onJson = onJson;
      this.onConnect = onConnect;
      this.onDisconnect = onDisconnect;
      if (this.socket && ((_a = this.socket) === null || _a === void 0 ? void 0 : _a.connected)) {
        if (((_c = (_b = this.socket) === null || _b === void 0 ? void 0 : _b.io.opts.extraHeaders) === null || _c === void 0 ? void 0 : _c.accessToken) === this.accessToken) {
          return true;
        }
      }
      this.socket = (0, socket_io_client_1.io)(this.server, {
        forceNew: true,
        reconnectionAttempts: 3,
        timeout: 2000,
        extraHeaders: {
          "Access-Token": this.accessToken
        }
      });
      this.socket.on("connect", function () {
        if (_this2.onConnect) {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          _this2.onConnect(args);
        }
      });
      (_d = this.socket) === null || _d === void 0 ? void 0 : _d.on('connect_failed', function () {
        _this2.log('socket client connection failed!');
      });
      (_e = this.socket) === null || _e === void 0 ? void 0 : _e.on('runtime_error', function (err) {
        _this2.log('socket client runtime error!', err.msg);
        var Toast = sweetalert2_1.default.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: function didOpen(toast) {
            toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
            toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
          }
        });
        Toast.fire({
          icon: 'error',
          title: err.msg || 'Some errors occured'
        });
      });
      (_f = this.socket) === null || _f === void 0 ? void 0 : _f.on('disconnect', function (reason) {
        if (_this2.onDisconnect) {
          _this2.onDisconnect(reason);
        }
      });
      (_g = this.socket) === null || _g === void 0 ? void 0 : _g.on('message', function () {
        if (_this2.onMessage) {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }
          _this2.onMessage(args);
        }
      });
      (_h = this.socket) === null || _h === void 0 ? void 0 : _h.on('json', function () {
        if (_this2.onJson) {
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          _this2.onJson(args);
        }
      });
      (_j = this.socket) === null || _j === void 0 ? void 0 : _j.on('block_chain_' + this.accessToken, function () {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        if (args.length > 0) {
          var trans = args[0];
          var Toast = sweetalert2_1.default.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: function didOpen(toast) {
              toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
              toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
            }
          });
          if (trans.tx && trans.act && trans.act == 'SUCCESS') {
            _this2.closeMonitor(trans.tx);
            if (trans.status && trans.status == 'SUCCEED') {
              _this2.log('1');
              Toast.fire({
                icon: 'success',
                title: 'Smart contract submit successfully'
              });
            } else if (trans.status && trans.status == 'FAILED') {
              _this2.log('0');
              Toast.fire({
                icon: 'warning',
                title: 'Smart contract submit failed'
              });
            }
          }
          if (trans.tx && trans.act && trans.act == 'CREATE') {
            if (trans.tx == '0x00') {
              _this2.closeMonitor(trans.tx);
              Toast.fire({
                icon: 'success',
                title: 'Smart contract submit successfully'
              });
            } else {
              setTimeout(function () {
                _this2.monitorTx(trans.domain, trans.chainid, trans.tx, 15);
              }, 3000);
            }
          }
          if (trans.act && trans.act == 'SIGN') {
            if (trans.wallet && trans.wallet == 'METAMASK') {} else {
              _this2.beforeConfirm(trans.domain, trans.chainid, trans.contract_address, trans.function, trans.args, trans.gas, trans.gas_price, trans.fee).then(function (trans) {
                if (_this2.onEmitChain) {
                  _this2.onEmitChain(trans);
                }
              });
            }
          }
        }
        if (_this2.onEmitChain) {
          _this2.onEmitChain(args);
        }
      });
      return true;
    }
  }, {
    key: "sendTx",
    value: function sendTx(domain, chainid, fun, args) {
      var _a, _b;
      if (!this.socket || !((_a = this.socket) === null || _a === void 0 ? void 0 : _a.connected)) {
        this.log('connection lost!');
        return;
      }
      (_b = this.socket) === null || _b === void 0 ? void 0 : _b.emit('tx_send', {
        domain: domain,
        chainid: chainid,
        function: fun,
        args: args
      });
    }
  }, {
    key: "monitorTx",
    value: function monitorTx(domain, chainid, tx, seconds) {
      var _this3 = this;
      var _a;
      (_a = this.socket) === null || _a === void 0 ? void 0 : _a.emit('tx_query', {
        domain: domain,
        chainid: chainid,
        tx: tx
      });
      if (seconds > 0) {
        setTimeout(function () {
          _this3.monitorTx(domain, chainid, tx, seconds - 3);
        }, 3000);
      } else {
        this.closeMonitor(tx);
      }
    }
  }, {
    key: "queryTx",
    value: function queryTx(chainid, tx) {
      var _a;
      (_a = this.socket) === null || _a === void 0 ? void 0 : _a.emit('tx_query', {
        chainid: chainid,
        tx: tx
      });
    }
  }, {
    key: "beforeConfirm",
    value: function beforeConfirm(domain, chainid, address, fun, args, gas, gasPrice, fee) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this4 = this;
        var transObj;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              transObj = {
                domain: domain,
                chainid: chainid,
                address: address,
                fun: fun,
                args: args,
                gas: gas,
                gasPrice: gasPrice,
                fee: fee,
                accessToken: this.accessToken
              };
              setTimeout(function () {
                document.getElementById('metisConfirmIframe').contentWindow.postMessage(transObj, _this4.confirmUrl.split('/#')[0]);
              }, 1000);
              sweetalert2_1.default.fire({
                title: 'Confirm your submit',
                html: "<iframe src=\"".concat(this.confirmUrl, "\" style=\"width: 100%; height: 480px;\" frameborder=\"0\" id=\"metisConfirmIframe\"></iframe>"),
                width: '720px',
                showConfirmButton: false
              });
              return _context.abrupt("return", new Promise(function (resolve) {
                var self = _this4;
                function globalMessage(event) {
                  if (event.origin !== "https://rocket.metis.io" && event.origin !== "https://polis.metis.io" && event.origin !== "http://localhost:1024") return;
                  if (event.data && event.data.tx) {
                    sweetalert2_1.default.close(self.swalPromise);
                    resolve(event.data);
                    window.removeEventListener("message", globalMessage, false);
                  }
                }
                window.addEventListener("message", globalMessage, false);
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "closeMonitor",
    value: function closeMonitor(tx) {
      this.removeConfirmMap(tx);
      this.disconnect();
      this.log('stop monitor for tx ' + tx);
    }
  }, {
    key: "removeConfirmMap",
    value: function removeConfirmMap(tx) {
      var ix = this.confirmArray.indexOf(tx);
      if (ix >= 0) {
        try {
          this.confirmArray.splice(ix, 1);
        } catch (x) {
          this.log(x.message);
        }
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _a;
      (_a = this.socket) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
  }, {
    key: "closeConfirmDialog",
    value: function closeConfirmDialog() {
      sweetalert2_1.default.close(this.swalPromise);
    }
  }]);
  return WebSocketClient;
}();
exports.WebSocketClient = WebSocketClient;